<template>
  <button
    type="button"
    class="login-social-btn"
  >
    <img
      v-if="image.length > 0"
      :src="image"
    >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'HButton',
  props: {
    image: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
  .login-social-btn {
    width: 100%;
    box-sizing: border-box;
    border: none;
    border-radius: 5px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s;
    font-size: 14px;
    padding: 0 20px;
    font-family: var(--font-bold);
    text-decoration: none;
    text-align: center;
    margin-bottom: 0;
    color: var(--color-white);
    background: var(--color-blue-200);

    img {
      margin-right: 10px;
      width: 33px;
      height: 33px;
    }

    &:hover {
      text-decoration: none;
      background: var(--color-blue-100);
    }
  }
</style>
